module.exports = __webpack_public_path__ + "static/media/email.5f08e03c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email.svg
// module id = 311
// module chunks = 0